export const generateColorCodeOptions = (filterConfigs) => {
  if (!filterConfigs || !Array.isArray(filterConfigs)) {
    return [];
  }
  
  const colorCodeOptions = [];
  
  // NOTE: "documentsType" (the Documents filter) is deliberately absent. Its values
  // are document ids, but the BE colour pipeline matches a path directly on the
  // annotation, and an annotation's `_id` is not its parent document's id. Don't
  // add it here without teaching generateColorBreakdownAggregationPipeline to
  // resolve the document ref per collection (meta.documentId on
  // annotations/chunks), the way getDocumentsTypeQuery does on the query side.
  const SUPPORTED_FILTER_TYPES = ['tagType', 'valuePathType', 'nestedRollupTagType'];
  const UNSUPPORTED_FILTER_TYPES = ['dateRangeType', 'dateType'];
  const UNSUPPORTED_FILTER_IDS = ['annoAuthorFilter', 'authorFilter', 'publishedDateFilter', 'annoEnabledBlockValuePathFilter'];
  
  for (const config of filterConfigs) {

    if (config?.configs && Array.isArray(config.configs)) {

        for (const subConfig of config.configs) {
            
            if (subConfig?.sectionTitle && subConfig?.configs) {
              const validConfigs = subConfig.configs.filter(item => {
                return SUPPORTED_FILTER_TYPES.includes(item?.target?.filterType) 
                  && !UNSUPPORTED_FILTER_IDS.includes(item?.filterId) 
                  && !UNSUPPORTED_FILTER_TYPES.includes(item?.target?.filterType);
              })

              if (validConfigs.length > 0) {
                const title = subConfig.sectionTitle
                const subtitle = subConfig?.sectionSubtitle
                const display = subtitle ? `${title} - ${subtitle}` : title;
                
                colorCodeOptions.push({
                  display: display,
                  value: subConfig.sectionId,
                  options: validConfigs
                });
              }

            }

        }
    }
  
  }
  
  return colorCodeOptions;
}
